import { FC, useContext } from 'react';

import { MoonIcon, SunIcon, Switch } from '@smartshell/ui-kit';

import { LocalizationContext } from 'localization';
import { ETheme, ThemeContext } from 'theme';

import s from './ThemeSwitcher.module.scss';

export const ThemeSwitcher: FC = () => {
  const { t } = useContext(LocalizationContext);
  const { theme, setTheme } = useContext(ThemeContext);

  return (
    <div className={s.container} data-onboarding="theme-switcher">
      {theme === 'dark' ? (
        <MoonIcon size="m" />
      ) : (
        <SunIcon size="m" color="link-info" />
      )}
      {t('theme.change')}
      <Switch
        className={s.switcher}
        onChange={(value) => setTheme(value ? ETheme.DARK : ETheme.LIGHT)}
        value={theme === ETheme.DARK}
      />
    </div>
  );
};
